/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const Happiness = z.object({ notes: z.string(), status: z.enum(['UNKNOWN', 'GREEN', 'YELLOW', 'RED']) })

export interface Happiness extends z.TypeOf<typeof Happiness> {}
